<div class="toaster position-fixed top-0 end-0 px-3 py-2 m-16" aria-live="polite">
  @for (toast of currentToasts(); track toast; let i = $index) {
    <div>
      <app-toast [type]="toast.type" [title]="toast.title" [message]="toast.message" (disposeEvent)="dispose(i)" />
    </div>
  }
</div>
